import React from "react";
import { Btn } from "../../../AbstractElements";
import RouteDropdown from "../../../Component/BasicComponents/Dropdowns/RouteDropdown";
import CustomInput from "../../../Component/BasicComponents/CustomInput";

type Props = {};

function OnboardOrganizationRecordModalContent({}: Props) {
  return (
    <div>
      <div className="row mb-2">
        <div className="col-sm-12">
          <RouteDropdown
            options={[]}
            //   value={formValues.grade || selectedRowData?.GradeId}
            onChange={(value: any) => {
              console.log("grade", value);
            }}
            DropdownHeading="Outlet Type"
          />
        </div>

        <div className="col-sm-12">
          <CustomInput
            label="Outlet Code"
            placeholder="Enter Outlet Code"
            type="text"
            name="name"
            //   value={formValues.name}
            //   onChange={handleInputChange}
          />
        </div>
        <div className="col-sm-12">
          <CustomInput
            label="Outlet Name"
            placeholder="Enter Outlet Name"
            type="text"
            name="name"
            //   value={formValues.name}
            //   onChange={handleInputChange}
          />
        </div>
      </div>

      <div className="d-flex justify-content-start gap-2">
        <Btn
          style={{ backgroundColor: "#43B9B2", color: "white", width: "100%" }}
          type="submit"
          // onClick={() =>
          //   handleSubmit({
          //     ...formValues,
          //     selectedOrgUnits: formValues.selectedOrgUnits.map(
          //       (item) => item.id
          //     ), // Extract only IDs here
          //   })
          // }
        >
          {"Update"}
        </Btn>
        <Btn
          style={{
            backgroundColor: "#F9FAFC",
            color: "#000",
            border: "1px solid #E0E0E0",
            width: "100%",
          }}
          type="button"
          // onClick={toggleEditClick}
        >
          Cancel
        </Btn>
      </div>
    </div>
  );
}

export default OnboardOrganizationRecordModalContent;
